const actions = {
  EditUser: "Edit User",
  EditOrganisation: "Edit Organisation",
};

export default actions;
